import React, { type ReactElement } from 'react';
import Loading from 'atom-components/loading';
import FullName from 'feature-components/full-name';
import LoadingErrorAlert from 'feature-components/loading-error-alert';
import {
  finishedReviewMarkStatuses,
  reviewMarkStatuses
} from 'helpers/domain-specific/mark-status.helpers';
import { useCustomerUser } from 'services/assist-api/entities/customer-user/customer-users';
import type { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';
import { isInitialLoad } from 'utils/check-query-status';

type Props = {
  activeReviewerId: number | undefined;
  markStatus: MarkStatus;
};

export default function Reviewer({ activeReviewerId, markStatus }: Props): ReactElement {
  const organisationUserQuery = useCustomerUser(activeReviewerId);

  const isLoading = isInitialLoad(organisationUserQuery);
  const { isError } = organisationUserQuery;

  function reviewerPrefix(): string {
    if (reviewMarkStatuses.includes(markStatus)) {
      return 'Being reviewed by';
    }
    if (finishedReviewMarkStatuses.includes(markStatus)) {
      return 'Reviewed by';
    }
    return 'Review assigned to';
  }

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && isError && <LoadingErrorAlert queries={[organisationUserQuery]} />}
      {!isLoading && !isError && (
        <div style={{ marginBottom: '20px' }}>
          {activeReviewerId ? (
            <span>
              {reviewerPrefix()} <FullName organisationUser={organisationUserQuery.data?.json} />.
            </span>
          ) : (
            "A reviewer hasn't been assigned to look at this mark."
          )}
        </div>
      )}
    </>
  );
}
